
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/news",
      function () {
        return require("private-next-pages/community/news/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/news"])
      });
    }
  